var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDesignerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.864405 21.9579L20.8438 19.5286L9.33462 0.890777L8.87559 10.3428C8.78244 12.2611 8.06653 14.0417 6.85149 15.3772L0.864405 21.9579Z",
    fill: "#84693B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDesignerArrow);
export default __webpack_public_path__ + "static/media/home_designerArrow.7b90719a1b48c5374dd3f13c58e7a0f5.svg";
export { ForwardRef as ReactComponent };